<div class="number-counter-container">
  <div class="number-counter">{{counter}}</div>
  <div class="number-counter-label">{{label}}</div>
</div>
